@if (faqs.length > 0) {
  @if (showTitle) {
    <div class="faq-title">
      <h3>FAQ's</h3>
      <kehe-phoenix-search
        placeholder="Search FAQ's"
        (valueChanged)="searchChanged($event)"
        style="width: 300px; margin-bottom: 8px"
      ></kehe-phoenix-search>
    </div>
  }
  <kehe-phoenix-faqs-accordion-list
    cardType="default"
    [faqs]="filteredFaqs"
  ></kehe-phoenix-faqs-accordion-list>
}
